import { render, staticRenderFns } from "./change-record.vue?vue&type=template&id=5935bdaf&scoped=true"
import script from "./change-record.vue?vue&type=script&lang=js"
export * from "./change-record.vue?vue&type=script&lang=js"
import style0 from "./change-record.vue?vue&type=style&index=0&id=5935bdaf&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5935bdaf",
  null
  
)

export default component.exports